export const HOST_VIEW = `import React, { useState, useEffect } from 'react';

export default function HostEventView({ pluginApi, pluginComponents, pluginStyles }) {
  // Safely access components with fallbacks
  const { 
    TextArea, 
    Button,
    AppButton,
    EventHeader,
    ContentPanel, 
    TextInput,
    Checkbox,
    Spinner,
    Alert
  } = pluginComponents || {};
  
  // Safely access styles with fallbacks
  const styles = {
    container: pluginStyles?.layout?.container || 'p-4',
    utils: {
      center: pluginStyles?.utils?.center || 'flex items-center justify-center',
    },
    text: {
      small: pluginStyles?.text?.small || 'text-sm text-white/70',
      subtitle: pluginStyles?.text?.subtitle || 'text-xl font-semibold text-white mb-3',
      title: pluginStyles?.text?.title || 'text-2xl font-bold text-white mb-4',
    }
  };

  // Plugin configuration state - still needed for display options
  const [config, setConfig] = useState({
    allowPersonalNotes: true,
    showActivityFeed: true,
    allowGuestsToPost: true,
    moderateBeforePost: false,
    feedTitle: 'Activity Feed',
    personalNotesTitle: 'Personal Notes',
  });

  console.log({config})
  // UI state
  const [loading, setLoading] = useState(true);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [error, setError] = useState('');
  const [activityFeed, setActivityFeed] = useState([]);
  const [personalNotes, setPersonalNotes] = useState('');

  // Load plugin data on mount
  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);
        
        // Load plugin configuration
        const configData = await pluginApi.getPluginConfig();
        if (configData && Object.keys(configData).length > 0) {
          setConfig(prevConfig => ({...prevConfig, ...configData, ...configData.pluginConfig}));
        }
        
        // Load activity feed data from event instance data
        const eventData = await pluginApi.getPluginEventInstanceData();
        if (eventData && eventData.activityFeed) {
          setActivityFeed(eventData.activityFeed);
        }
        
        // Load personal notes from user plugin data
        const userData = await pluginApi.getEventPluginUserData();
        if (userData && userData.personalNotes) {
          setPersonalNotes(userData.personalNotes);
        }
      } catch (err) {
        console.error('Error loading plugin data:', err);
        setError('Failed to load plugin data. Please try refreshing.');
      } finally {
        setLoading(false);
      }
    }
    
    loadData();
  }, []);

  // Save personal notes
  const savePersonalNotes = async () => {
    try {
      await pluginApi.saveEventPluginUserData({ personalNotes });
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving notes:', err);
      setError('Failed to save notes. Please try again.');
      setTimeout(() => setError(''), 3000);
    }
  };

  // Delete activity feed entry
  const deleteActivityEntry = async (entryId) => {
    try {
      const updatedFeed = activityFeed.filter(entry => entry.id !== entryId);
      await pluginApi.savePluginEventInstanceData({ activityFeed: updatedFeed });
      setActivityFeed(updatedFeed);
    } catch (err) {
      console.error('Error deleting entry:', err);
      setError('Failed to delete entry. Please try again.');
      setTimeout(() => setError(''), 3000);
    }
  };

  if (loading) {
    return (
      <div className={styles.utils.center} style={{height: "200px"}}>
        {Spinner ? <Spinner size="large" /> : <div>Loading...</div>}
      </div>
    );
  }

  return (
    <div className="video-preview p-4 bg-transparent">
        <div className="relative">
          <div className="flex items-center gap-2">
            
            <div>
              <div className="text-white/50 text-base">{config.experimentTitle}</div>
            </div>
            
          </div>
          
          <div className="text-white text-base mt-4 text-left">
            {config.experimentDescription}
          </div>
          <hr className="w-full border-white/30 my-4" />

          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2">
              <div className="text-white text-base flex items-center">
                <span className="line-through text-gray-400 mr-2">
                  $ {config.experimentPrice}/invite
                </span>
                <span className="text-white font-medium">$ {config.experimentDiscountedPrice}/invite</span>
                <span className="ml-2 bg-white/10 text-white text-[12px] px-1 rounded">
                  {Math.round((config.experimentPrice - config.experimentDiscountedPrice)*100/config.experimentPrice)}% OFF
                </span>
              </div>
            </div>

            <button
              type="button"
              onClick={()=>{}}
              className="w-full bg-white/10 text-white py-3 px-4 rounded-lg transition-colors"
            >
              {config.experimentTrackingCTAText}
            </button>
          </div>
        </div>
      </div>
  );
}`
